// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2wHYt","right":"styles_right__37NRV"};